document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelectorAll(".PDP-swiper").length) {
        new Swiper(".swiper", {
            spaceBetween: 0,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }

    // Toggle menus
    $("#etleeToggles").on("click", ".PDP-toggle-btn", function () {
    var $btn = $(this);
    var target = $btn.data("target");
    var $content = $(target);
    var isHidden = !$content.is(":visible");
    $btn.find(".etlee-toggle-icon").text(isHidden ? "-" : "+");
    $content.stop(true, true).slideToggle(250);
    });

    // Size options
    $("#etleeSizeOptions").on("click", ".PDP-size-option", function () {
    $("#etleeSizeOptions .PDP-size-option")
        .removeClass("etlee-active")
        .css("opacity", 0.25);
    $(this).addClass("etlee-active").css("opacity", 1);
    });

    //======================= Handle drag scroll for Image Col ===============================
    // const container = document.querySelector('.PDP-image-column');

    // let isDown = false;
    // let startY, scrollTop, lastY, velocity = 0;
    // let momentumID;

    // if (container) {
    //     container.addEventListener('mousedown', e => {
    //     isDown = true;
    //     startY = e.pageY;
    //     scrollTop = container.scrollTop;
    //     velocity = 0;
    //     cancelMomentum(); 
    //     });

    //     container.addEventListener('mousemove', e => {
    //     if (!isDown) return;
    //     e.preventDefault();

    //     const y = e.pageY;
    //     const delta = y - startY;
    //     container.scrollTop = scrollTop - delta;

    //     velocity = y - lastY;
    //     lastY = y;
    //     });

    //     container.addEventListener('mouseup', () => {
    //     isDown = false;
    //     startMomentumScroll();
    //     });

    //     container.addEventListener('mouseleave', () => {
    //     isDown = false;
    //     });
    // }

    // function startMomentumScroll() {
    // cancelMomentum();
    // momentumID = requestAnimationFrame(momentumLoop);
    // }

    // function momentumLoop() {
    // container.scrollTop -= velocity;
    // velocity *= 0.95; 
    // if (Math.abs(velocity) > 0.5) {
    //     momentumID = requestAnimationFrame(momentumLoop);
    // }
    // }

    // function cancelMomentum() {
    // cancelAnimationFrame(momentumID);
    // }
    // =======================================

    // Sticky bottom
    const $win = $(window);
    function updateStickyBottom() {
    $(".PDP-col-parent").each(function () {
        const $parent = $(this);
        const $sticky = $parent.find(".etlee-sticky");
        if (!$sticky.length) return;

        const parentTop = $parent.offset().top;
        const parentHeight = $parent.outerHeight();
        const parentBottom = parentTop + parentHeight;
        const stickyHeight = $sticky.outerHeight();
        const scrollBottom = $win.scrollTop() + $win.height();
        const bottomGap =
        parseInt(
            getComputedStyle(document.documentElement).getPropertyValue(
            "--etlee-sticky-bottom"
            )
        ) || 20;

        if (parentHeight <= stickyHeight) {
        $sticky
            .css({ position: "", bottom: "", width: "", left: "" })
            .removeClass("PDP-anchored-bottom");
        return;
        }

        const parentLeft = $parent.offset().left;
        const parentWidth = $parent.innerWidth();

        // Sticky at bottom instead of top
        if (scrollBottom - bottomGap - stickyHeight <= parentTop) {
        // above parent => static
        $sticky
            .css({ position: "", bottom: "", width: "", left: "" })
            .removeClass("PDP-anchored-bottom");
        } else if (scrollBottom - bottomGap >= parentBottom) {
        // reached bottom
        $sticky
            .css({
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            })
            .addClass("PDP-anchored-bottom");
        } else {
        // fixed to bottom of viewport
        $sticky
            .css({
            position: "fixed",
            bottom: bottomGap + "px",
            left: parentLeft + "px",
            width: parentWidth + "px",
            })
            .removeClass("PDP-anchored-bottom");
        }
    });
    }

    updateStickyBottom();
    $win.on("scroll resize", updateStickyBottom);

    // $(window).on("scroll", function () {
    //     let productDetailSection = $(".product-detail-banner");

    //     let bannerTop = productDetailSection.offset().top;
    //     let bannerHeight = productDetailSection.outerHeight();
    //     let bannerEnd = bannerTop + bannerHeight;

    //     let footerTop = $("footer").offset().top;
    //     let windowHeight = $(window).height();

    //     let scrollTop = $(window).scrollTop();

    //     let touchFooter = scrollTop + windowHeight >= footerTop;

    //     if (touchFooter) {
    //         $(".btn-shop-now").fadeOut();
    //         return;
    //     }

    //     if (scrollTop >= bannerTop && scrollTop <= bannerEnd) {
    //         $(".btn-shop-now").fadeIn();
    //     } else {
    //         $(".btn-shop-now").fadeOut();
    //     }
    // });
});

